export enum UnsubscribeQueryRequiredParamsName {
  Address = 'address',
  IsGroup = 'is_group',
}

enum UnsubscribeQueryNotRequiredParamsName {
  IsMember = 'is_member',
}

const UnsubscribeQueryParamsNameObj = {
  ...UnsubscribeQueryRequiredParamsName,
  ...UnsubscribeQueryNotRequiredParamsName,
};

export interface UnsubscribeQueryParams {
  [UnsubscribeQueryParamsNameObj.Address]: string;
  [UnsubscribeQueryParamsNameObj.IsGroup]: string;
  [UnsubscribeQueryParamsNameObj.IsMember]?: string;
}
